<template>
  <div>
    <!-- 大咖的信息 -->
    <teacher :data="teacher" class="border-bottom" v-if="isDaka"></teacher>
    <div class="content-wrapper">
      <div class="content" :class="{open:open}" ref="con">
        <h4>课程详情</h4>
        <div v-html="twxqContent" class="introContainer"></div>
        <!-- 展开更多 -->
        <div class="more" @click="open=true" v-if="needZheDie&&!open">
          <p>查看更多详情 ></p>
        </div>
        <div class="close" v-if="needZheDie&&open">
          <p @click="open=false">收起详情 <span>^</span></p>
        </div>
      </div>
      <!-- 打赏 -->
      <div class="shang-txt">觉得课程不错，给老师个鼓励吧！<img src="~@/common/image/ds-line.png" alt=""></div>
      <div class="shang" @click="dashangDialog=true;controlVideo('hide')">
        <i class="iconfont icon-dashang"></i>
        <span>点击打赏</span>
      </div>
      <div class="shang-user-txt" v-if="shangNum">
        <div class="line border-bottom"></div>
        <div class="m"><span>{{shangNum}} </span>人喜欢</div>
        <div class="line border-bottom"></div>
      </div>
      <div class="shang-user" v-if="shangNum">
        <div class="img-wrap" v-for="item in shang" :key="item.avatar"><img v-lazy="item.avatar" alt=""></div>
      </div>
    </div>
    <!-- 打赏对话框 -->
    <dashang-dialog :courseId="courseId" :videoId="videoId" v-if="dashangDialog" @close="dashangDialog=false;controlVideo('show')"></dashang-dialog>
    <!-- 评论 -->
    <div class="comment-top-wrap border-top">
      <comment-list :videoId="videoId" :courseId="courseId" :bought="bought" :controlVideo="controlVideo"></comment-list>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import Scroll from 'components/base/scroll/scroll'
import Teacher from 'components/base/ui/teacher'
import CommentList from './play-kcpj'
import DashangDialog from './play-dashang-dialog'
export default {
  props: {
    twxqContent: {
      type: String,
      default: ''
    },
    teacher: {
      type: Object,
      default: null
    },
    // 以下参数给评论组件用的
    videoId: {
      type: String,
      default: ''
    },
    courseId: {
      type: String,
      default: ''
    },
    bought: {
      type: Boolean,
      default: false
    },
    // 打赏信息
    shang: {
      type: Array,
      default: null
    },
    shangNum: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      // title: '图文详情'
      needZheDie: false, // 判断详情是否太长
      open: true, // 是否只展开状态
      dashangDialog: false,
      inDialog: false
    }
  },
  created() {
    // this.$emit('setTitle', this.title)
  },
  activated() {
    // this.$emit('setTitle', this.title)
  },
  mounted() {
    // 处理折叠效果
    // console.log(this.$refs.con.getBoundingClientRect())
    let timer = null
    const interval = 200 // 毫秒
    const cb = () => {
      const con = this.$refs.con
      const rect = con && con.getBoundingClientRect && con.getBoundingClientRect()
      if (con && rect && rect.height > 210) { // 和下面样式设置高度保持一致
        this.needZheDie = true
        this.open = false
        clearInterval(timer)
        timer = null
      }
    }
    timer = setInterval(cb, interval)
    // 超过10s就不检查了
    setTimeout(() => {
      if (timer) {
        clearInterval(timer)
        timer = null
      }
    }, 10 * 1000)
  },
  computed: {
    isDaka() {
      // 不是大咖就不显示
      // 不是大咖的时候就是空数组,后台接口就是这样的
      return !(!this.teacher || this.teacher.length === 0)
    }
  },
  methods: {
    controlVideo(action) { // show or hide
      // 显示评论框
      // 隐藏播放器
      this.$emit('controlVideo', action)
      // 隐藏评论框
      // 显示播放器
    }
  },
  components: {
    Scroll,
    Teacher,
    CommentList,
    DashangDialog
  }
}
</script>
<style lang="stylus" ref="stylesheet/stylus">
/* 这个没有启用scoped 其他地方也会受影响 */
.introContainer
  line-height 1.4
  word-wrap break-word
  word-break break-all
  img
    width 100%!important
</style>

<style scoped lang="stylus" ref="stylesheet/stylus">
  @import "~common/stylus/variable"
  .content-wrapper
    padding-bottom size(0)
  .content
    padding size(30)
    padding-bottom 0
    position relative
    height 210px // 这个图文详情的最大展示高度，配合查看更多
    overflow hidden
    &.open
      height auto
      overflow visible
      .more
        display none
    .more
      z-index 1
      position absolute
      left 0
      bottom -1px
      width 100%
      text-align center
      font-size size(28)
      color $color-theme
      padding-top size(80)
      background linear-gradient(to top, rgba(255,255,255,1), rgba(255,255,255,.7))
      p
        // background red
        line-height 2
    .close
      text-align center
      font-size size(30)
      color $color-theme
      padding size(40) 0
      span
        position relative
        top 2px
  h4
    line-height size(60)
    font-size size(34)
    margin-bottom size(20)
  .shang-txt
    margin-top size(20)
    font-size size(30)
    padding size(20) 0
    text-align center
    position relative
    font-weight 800
    img
      position absolute
      bottom 0
      left 50%
      transform translateX(-50%)
      width size(420)!important
  .shang
    font-size size(30)
    color $color-theme
    text-align center
    line-height size(60)
    border-radius 4px
    border 1px solid $color-theme
    width size(208)
    margin size(50) auto
    font-weight 800
    .iconfont
      font-size 20px
      font-weight 500
      position relative
      top 1px
  .shang-user-txt
    display flex
    align-items center
    font-size size(24)
    padding 0 size(220)
    color #999
    .m
      padding 0 size(12)
    .line
      flex 1
    span
      color #333
  .shang-user
    text-align center
    font-size 0
    margin-top size(20)
    .img-wrap
      display inline-block
      width size(56)
      height size(56)
      border-radius 50%
      background #dddddd
      overflow hidden
      margin 0 size(8)
      img
        width 100%
  .comment-top-wrap
    margin-top size(40)
    // padding-bottom size(100)
</style>



// WEBPACK FOOTER //
// src/components/play/play-twxq.vue